import FieldProto from "../../proto/field-proto";
import FieldAttachments_InlineEditable from "./render/inline-editable";
import FieldAttachments_GListView from "./render/glist-view";
import FieldAttachments_Popover from "./components/popover";
import FieldAttachments_FormElement from "./render/form-element";
import {SortDirection} from "../../../data-structures/sort";

// const debug = "FieldAttachments"
const debug = false

export default class FieldAttachments extends FieldProto {

    constructor(config:any) {
        super(config);

        this.typeLabel   =   "Attachments"
        this.icon        =   "i5-attachment"

        this.components.PopoverMenu          = FieldAttachments_Popover

        this.renderComponents.formElement    = FieldAttachments_FormElement
        this.renderComponents.glistView      = FieldAttachments_GListView
        this.renderComponents.inlineEditable = FieldAttachments_InlineEditable

    }

    // normalize value for sorting
    sortValue(value:any, model?:any) {
        debug && console.log(debug, 'sortValue', value)

        const orderedAttachments = _.orderBy(value, attachment => attachment.name, SortDirection.ASC )
        return '{0}_{1}'.f(orderedAttachments.length, _.map(orderedAttachments, attachment => attachment.name.toLowerCase()))
    }

    normalizeToCSVValue(model:any): any {
        const rawValue = super.normalizeToCSVValue(model)
        const res: string[] | null = !_.isEmpty(rawValue) ? _.map(rawValue, attachment => attachment.name) : null
        return !!res ? res.join(', ') : ''
    }
}
